import axios from 'axios';
import { GLOBAL_COOKIE_NAME } from 'features/common/constants';
import { Cookies } from 'react-cookie-consent';
import { refresh } from './n2-auth';

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 300000,
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY || '',
  },
});

client.interceptors.request.use(config => {
  const cookie = Cookies.get(GLOBAL_COOKIE_NAME);
  const parsedCookie =
    cookie && typeof cookie === 'string' ? JSON.parse(cookie) : undefined;

  if (config.headers) {
    config.headers.Authorization = `Bearer ${parsedCookie?.token}` || '';
  }
  return config;
});

client.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest.iamretry
    ) {
      originalRequest.iamretry = true;
      const cookie = Cookies.get(GLOBAL_COOKIE_NAME);
      const parsedCookie =
        cookie && typeof cookie === 'string' ? JSON.parse(cookie) : undefined;

      const response = await refresh({
        refreshToken: parsedCookie.refreshToken,
      });
      const data = await response.json();

      axios.defaults.headers.common.Authorization = data?.accessToken;

      Cookies.set(GLOBAL_COOKIE_NAME, {
        token: data?.accessToken,
        refreshToken: data?.refreshToken,
      });

      client(originalRequest);
    } else if (
      error.response &&
      error.response.status === 401 &&
      originalRequest.iamretry
    ) {
      Cookies.remove(GLOBAL_COOKIE_NAME);
      alert('You do not have enough access rights'); // Login Component does not have any error messaging?
      window.location.href = '/';
    } else if (error.response && error.response.status === 403) {
      Cookies.remove(GLOBAL_COOKIE_NAME);
      alert('You do not have enough access rights');
      window.location.href = '/';
    }

    return Promise.reject(error);
  },
);
